var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Products',{attrs:{"finance_configuration_category":_vm.finance_configuration_category},on:{"get_finance_configuration_category":_vm.financeConfigurationCategory}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }